import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { WarrantyReminderConfigComponent } from './warranty-reminder-config/warranty-reminder-config.component';
import { WarrantyReminderReadonlyComponent } from './warranty-reminder-readonly/warranty-reminder-readonly.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    WarrantyReminderConfigComponent,
    WarrantyReminderReadonlyComponent
  ],
  exports: [
    WarrantyReminderConfigComponent,
    WarrantyReminderReadonlyComponent
  ]
})
export class WarrantyReminderModule { }



// WEBPACK FOOTER //
// /app/src/app/common/components/warranty-reminder/warranty-reminder.module.ts